export const toUnixSecondsQueryParam = (date: Date | null | undefined) =>
  String(Math.floor(Number(date ?? null) / 1000) || '');
